import { render, staticRenderFns } from "./FormularioReposoAsistencia.vue?vue&type=template&id=64b8a3d0&scoped=true"
import script from "./FormularioReposoAsistencia.vue?vue&type=script&lang=js"
export * from "./FormularioReposoAsistencia.vue?vue&type=script&lang=js"
import style0 from "./FormularioReposoAsistencia.vue?vue&type=style&index=0&id=64b8a3d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8a3d0",
  null
  
)

export default component.exports